import { render } from "./NavigationBar.vue?vue&type=template&id=ffe06ac2&scoped=true"
import script from "./NavigationBar.vue?vue&type=script&lang=js"
export * from "./NavigationBar.vue?vue&type=script&lang=js"

import "./NavigationBar.vue?vue&type=style&index=0&id=ffe06ac2&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src718038542/src/nickyadvokaat-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ffe06ac2"]])

export default __exports__